import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { Login } from '@pages/Login';
import { Website } from '@pages/Website';
import { EnhancedDashboard } from '@pages/EnhancedDashboard';
import { ARInvoices } from '@pages/ARInvoices';
import { APInvoices } from '@pages/APInvoices';
import { Logs } from '@pages/Logs';
import { PurchaseOrders } from '@pages/PurchaseOrders';
import { POMatching } from '@pages/POMatching';
import { Settings } from '@pages/Settings';
import { ProtectedRoute } from '@components/ProtectedRoute';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/" element={<Website />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <EnhancedDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ar-invoices"
            element={
              <ProtectedRoute>
                <ARInvoices />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ap-invoices"
            element={
              <ProtectedRoute>
                <APInvoices />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <ProtectedRoute>
                <Logs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase-orders"
            element={
              <ProtectedRoute>
                <PurchaseOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/po-matching"
            element={
              <ProtectedRoute>
                <POMatching />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
